// extracted by mini-css-extract-plugin
export default {"thoughtProcess":"analysis-panel_thoughtProcess__WhDa-","closeBtn":"analysis-panel_closeBtn__HqewX","pdfZone":"analysis-panel_pdfZone__3e8GM"};